export default "__VITE_ASSET__DnU321v3__"